import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { OrderConversionChart } from './OrderConversionChart';

export const orderConversionChartResource: ResourceProps = {
  name: Resources.OrderConversionChart,
  create: <></>,
  edit: <></>,
  show: <></>,
  list: OrderConversionChart,
};
